import {HStack} from "_ui/Box";
import companyLogo from "_assets/images/reeducation.png";
import googlePartner from "_assets/images/google-education-partner.jpg";
import {LimitedWidth} from "_page/LimitedWidth";

export const Footer = () => {
    return (
        <HStack wFull className='p-3 default-client-footer' alignCenter wrap g={3}>
            <LimitedWidth>
                <HStack wFullVw alignCenter g={3} id="img-footer">
                    <HStack alignCenter g={1}>
                        <img src={companyLogo} alt="company-logo" style={{maxWidth: 150}}/>
                        <p className='m-0 fs-3' style={{height: '27px'}}>{'| ' + new Date().getFullYear()}</p>
                    </HStack>

                    {/* <img src={googlePartner} alt='google-partner' style={{maxWidth: 150}}/> */}

                </HStack>
            </LimitedWidth>
        </HStack>
    );
}
